import { render, staticRenderFns } from "./PostIconAndTextMetric.vue?vue&type=template&id=5a71480c&scoped=true&"
import script from "./PostIconAndTextMetric.vue?vue&type=script&lang=js&"
export * from "./PostIconAndTextMetric.vue?vue&type=script&lang=js&"
import style0 from "./PostIconAndTextMetric.vue?vue&type=style&index=0&id=5a71480c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a71480c",
  null
  
)

export default component.exports